import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <section className="min-h-[70vh] grid place-items-center px-6 text-center">
      <div>
        <div className="font-serif text-7xl text-primary">404</div>
        <h1 className="font-serif text-3xl mt-4">Page not found</h1>
        <p className="text-muted-foreground mt-2">Let&apos;s get you back to smiling.</p>
        <Link to="/"><Button className="mt-6 rounded-full" data-testid="notfound-home">Back to Home</Button></Link>
      </div>
    </section>
  );
}
